import styled from 'styled-components';

const GWFCard = styled.div`
  border: 1px solid #21aae8;
  border-radius: 7px;
  display: flex;
  padding: 32px 16px;
  margin-bottom: 16px;
  .content {
    margin-left: 32px;
    align-items: center;
  }
  img {
    width: 120px;
    height: auto;
  }
`;

export default {
  GWFCard,
};
